var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7507 4.125V11C19.7507 13.2743 17.9 15.125 15.6257 15.125H9.51386L6.49023 17.7155C6.77073 17.8117 7.06498 17.875 7.37573 17.875H13.9964L18.615 21.835C18.7429 21.9436 18.9024 22 19.0632 22C19.1609 22 19.2599 21.9794 19.3506 21.9368C19.5954 21.8254 19.7507 21.5806 19.7507 21.3125V17.875C21.2674 17.875 22.5007 16.6416 22.5007 15.125V6.875C22.5007 5.35837 21.2674 4.125 19.7507 4.125Z",
    fill: "#4299E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625 13.75C17.1416 13.75 18.375 12.5166 18.375 11V2.75C18.375 1.23337 17.1416 0 15.625 0H3.25C1.73337 0 0.5 1.23337 0.5 2.75V11C0.5 12.5166 1.73337 13.75 3.25 13.75V17.1875C3.25 17.4556 3.40675 17.7004 3.65012 17.8118C3.74225 17.8544 3.83987 17.875 3.9375 17.875C4.09838 17.875 4.25787 17.8186 4.38438 17.71L9.00437 13.75H15.625ZM5.3125 4.125H13.5625C13.942 4.125 14.25 4.433 14.25 4.8125C14.25 5.192 13.942 5.5 13.5625 5.5H5.3125C4.933 5.5 4.625 5.192 4.625 4.8125C4.625 4.433 4.933 4.125 5.3125 4.125ZM4.625 7.5625C4.625 7.183 4.933 6.875 5.3125 6.875H10.8125C11.192 6.875 11.5 7.183 11.5 7.5625C11.5 7.942 11.192 8.25 10.8125 8.25H5.3125C4.933 8.25 4.625 7.942 4.625 7.5625Z",
    fill: "#4299E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.20e6745ce6c9dd62b65fed9772014808.svg";
export { ForwardRef as ReactComponent };